import React from 'react';
import styled from 'styled-components';
import { AspectRatioImageFill } from '../AspectRatioImage';
import variables from '@ingka/variables/design-tokens';
import cssIngka from '@ingka/variables/colours-css';
import { useTranslation } from '@ikea-customer-self-serve/gatsby-plugin-translations';

export interface ProductCardProps {
  name: string;
  productId: string;
  typeName: string;
  imgUrl: string;
}

const ProductCardContainer = styled.div`
  display: flex;
  padding-left: 12px;
  padding-right: 12px;
  @media (min-width: ${variables.breakpointM}) {
    margin-right: auto;
    width: 50%;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  width: 102px;
  height: 102px;
  align-items: center;
  margin-inline-end: 20px;
  margin-bottom: 20px;
  @media (min-width: ${variables.breakpointM}) {
    width: 128px;
    height: 128px;
  }
`;

const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const DetailsName = styled.div`
  margin-top: 8px;
  text-transform: uppercase;
  font-weight: ${variables.fontWeightBold};
`;

const DetailsTypeName = styled.div`
  color: ${cssIngka.colourNeutral5};
  font-size: 12px;
`;

const DetailsId = styled.div`
  font-weight: ${variables.fontWeightBold};
  background-color: ${cssIngka.colourNeutral2};
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 2px;
  width: 84px;
  font-size: 12px;
`;

const DetailsIdWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 4px;
`;

const addDotSeparator = (text: string) => {
  if (!text) return text;

  const textArray = Array.from(text);
  textArray.splice(3, 0, '.');
  textArray.splice(7, 0, '.');
  textArray.join('');
  return textArray;
};

const ProductCard = ({
  name,
  imgUrl = '',
  typeName,
  productId,
}: ProductCardProps) => {
  const dotSeparatedProductId = addDotSeparator(productId);
  const { t } = useTranslation();

  return (
    <ProductCardContainer>
      <ImageWrapper>
        <AspectRatioImageFill src={imgUrl} alt="" />
      </ImageWrapper>
      <ProductDetails>
        <DetailsName>
          {name ? name : t(`spareParts.status.notAvailable`)}
        </DetailsName>
        <DetailsTypeName>
          {typeName ? typeName : t(`spareParts.status.notAvailable`)}
        </DetailsTypeName>
        <DetailsIdWrapper>
          <DetailsId>{dotSeparatedProductId}</DetailsId>
        </DetailsIdWrapper>
      </ProductDetails>
    </ProductCardContainer>
  );
};

export default ProductCard;
